import React from 'react'
import HomePageStyled from './Homepage.styles'
import Directory from '../../Components/Directory/Directory.component'
const HomePage = () => {
  return (
    <HomePageStyled>
      <Directory />
    </HomePageStyled>
  )
}

export default HomePage
